enum AnnotationSquareFunctionFields {
	CREATOR = "creator",
	SUBJECT = "subject",
	CONTENTS = "contents",
	INTENTS = "intents",
	BORDER = "border",
	OPACITY = "opacity",
	STROKE = "stroke",
	STYLE = "style",
	FILL = "fill",
	DRAW_MODE = "draw_mode"
}

export default AnnotationSquareFunctionFields;